// useDismiss — общий хук «закрыть по Esc / по клику вне». Используют ContextMenu, Modal, MediaViewer.
// Презентационный: только слушатели DOM-событий, никакого доменного состояния.
import { useEffect } from 'react';
/** Вешает document-listeners на время open и снимает при закрытии/размонтировании. */
export function useDismiss({ open, onClose, ref, closeOnEscape = true, closeOnOutside = true, }) {
    useEffect(() => {
        if (!open)
            return;
        if (typeof document === 'undefined')
            return;
        const onKey = (e) => {
            if (closeOnEscape && e.key === 'Escape') {
                e.stopPropagation();
                onClose();
            }
        };
        const onPointer = (e) => {
            if (!closeOnOutside)
                return;
            const el = ref?.current;
            if (el && e.target instanceof Node && !el.contains(e.target))
                onClose();
        };
        document.addEventListener('keydown', onKey, true);
        // mousedown, чтобы закрытие случилось до клика по новой цели
        document.addEventListener('mousedown', onPointer, true);
        return () => {
            document.removeEventListener('keydown', onKey, true);
            document.removeEventListener('mousedown', onPointer, true);
        };
    }, [open, onClose, ref, closeOnEscape, closeOnOutside]);
}
//# sourceMappingURL=useDismiss.js.map